import { Routes, Route, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import JoinPage from './pages/JoinPage';
import InvitationPage from './pages/InvitationPage';
import TastingPage from './pages/TastingPage';
import PreparedTastingPage from './pages/PreparedTastingPage';
import CompletedPage from './pages/CompletedPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  return (
    <AnimatePresence mode="wait">
      <Routes>
        {/* Prepared tasting by UUID - must be before /:accessCode */}
        <Route path="/tasting/:uuid" element={<PreparedTastingPage />} />

        {/* Join by access code */}
        <Route path="/:accessCode" element={<JoinPage />} />

        {/* Join by invitation token */}
        <Route path="/invite/:token" element={<InvitationPage />} />

        {/* Active tasting session */}
        <Route path="/session/:sessionId" element={<TastingPage />} />

        {/* Completed tasting */}
        <Route path="/completed/:sessionId" element={<CompletedPage />} />

        {/* Redirect root to 404 (requires access code) */}
        <Route path="/" element={<NotFoundPage />} />

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AnimatePresence>
  );
}

export default App;
